import { useEffect, useState } from 'react';

const useEventAttendeePdf = event => {
    const [eventAttendeePdf, setEventAttendeePdf] = useState();

    useEffect(() => {
        if (!event?.quicklinks) {
            return;
        }

        const attendeeListLink = event.quicklinks.find(quicklink =>
            quicklink.quicklink_name.toUpperCase().includes('ATTENDEE LIST')
        );

        if (attendeeListLink) {
            setEventAttendeePdf(attendeeListLink.quicklink_url);
        }
    }, [event]);

    return { eventAttendeePdf };
};

export default useEventAttendeePdf;
